import { Drawer } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { LOCATIONS_CREATE, LOCATIONS_EDIT, LOCATIONS_VIEW } from '../../../constants/LocationConst';
import { validateUserSession } from '../../../utils/authUtils';
import { selectedHotelSelector } from '../../property/propertySlice';
import LocationCreate from './location-create/Location-Create';
import LocationList from './location-list/Location-List';
import LocationView from './location-view/Location-View';

const Location = (props) => {
  const { permissions, showLoader = () => {} } = props;
  const [state, setState] = useState({ type: LOCATIONS_CREATE, status: false });
  const selectedHotel = useSelector(selectedHotelSelector);
  const [viewState, setViewState] = useState({
    type: LOCATIONS_VIEW,
    status: false,
    obj: null,
  });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const history = useHistory();
  const onDrawerToggle = (type, status, obj) => {
    setState({ type: type, status: status, obj: obj });
  };

  const toggleDrawer = (open) => (event, reason) => {
    if (
      reason === 'backdropClick' ||
      (event?.type === 'keydown' && (event?.key === 'Tab' || event?.key === 'Shift'))
    ) {
      return;
    }
    setState(open);
  };

  const onViewToggle = (type, status, obj) => {
    setViewState({ type: type, status: status, obj: obj });
  };

  const switchDrawerContent = (state) => {
    switch (state.type) {
      case LOCATIONS_CREATE:
        return (
          <LocationCreate
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            showLoader={showLoader}
          ></LocationCreate>
        );
      case LOCATIONS_EDIT:
        return (
          <LocationCreate
            toggleDrawer={onDrawerToggle}
            location={state.obj}
            hotelId={selectedHotel}
            showLoader={showLoader}
          ></LocationCreate>
        );
      default:
        break;
    }
  };

  const switchViewContent = (inpState) => {
    switch (inpState.type) {
      case LOCATIONS_VIEW:
        return (
          <LocationView
            location={inpState.obj}
            onViewToggle={onViewToggle}
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            permissions={permissions}
          ></LocationView>
        );
      default:
        break;
    }
  };

  useEffect(() => {
    validateUserSession(history);
  }, [history]);

  return (
    <>
      <Drawer
        anchor={'right'}
        open={state.status}
        onClose={toggleDrawer(false)}
        className='right-drawer'
      >
        {switchDrawerContent(state)}
      </Drawer>
      {viewState.status && <>{switchViewContent(viewState)}</>}
      {!viewState.status && (
        <div className='container mt-4'>
          <div className='row d-flex'>
            <div className='col-md-6'>
              <span className='page-title'>Locations</span>
            </div>
            <div className='col-md-6 d-flex justify-content-end'>
              {/* sync button might come in the future sprint */}
              {/* <IconButton
                className="shadow"
              >
                <CloudCircleIcon />
              </IconButton> */}
            </div>
          </div>
          <div className='row mx-2 d-flex mt-4'>
            <div className='card shadow'>
              <LocationList
                permissions={permissions}
                onDrawerToggle={onDrawerToggle}
                onViewToggle={onViewToggle}
                selectedHotel={selectedHotel}
                state={state}
                onsetPage={(e) => setPage(e)}
                page={page}
                onsetRowsPerPage={(e) => setRowsPerPage(e)}
                rowsPerPage={rowsPerPage}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Location;
